import Vue from 'vue';
import VueResource from 'vue-resource';

Vue.use(VueResource);

export default {
  liberar: (solicitacao, id, coordenador) => {
    return Vue.http.post(`/api/liberarsolicitacao/${solicitacao}/${id}/${coordenador}`)
      .then(response => response.data);
  },
  cancelar: (solicitacao, id, coordenador) => {
    return Vue.http.post(`/api/cancelarsolicitacao/${solicitacao}/${id}/${coordenador}`)
      .then(response => response.data);
  },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/liberar-cancelar-solicitacao/servico.js